export default "__VITE_ASSET__f5dfb56f__"